import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiArrowRight, FiActivity, FiLayers, FiShield } = FiIcons;

export default function Hero() {
  const scrollToContact = (e) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToSolutions = (e) => {
    e.preventDefault();
    document.getElementById('solutions')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-screen flex items-center pt-20 bg-[#050505] overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#DFFF00]/5 to-transparent pointer-events-none" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-[#DFFF00]/5 blur-[120px] rounded-full pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-6 w-full relative z-10">
        <div className="max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-12 bg-[#DFFF00]" />
              <span className="text-[#DFFF00] text-[10px] font-black uppercase tracking-[0.4em]">Zero-to-Scale Deployment Protocol</span>
            </div>
            
            <h1 className="text-6xl md:text-[110px] font-black leading-[0.85] tracking-tighter uppercase text-white mb-10 italic">
              Saturate <br />
              <span className="text-[#DFFF00] text-glow">The Feed.</span>
            </h1>
            
            <p className="text-xl md:text-2xl text-slate-300 max-w-2xl leading-relaxed mb-12 font-medium">
              Industrial social media distribution and AI creative infrastructure. From mass account nodes to AI-forged commercials and influencers.
            </p>

            <div className="flex flex-col sm:flex-row gap-6">
              <button 
                onClick={scrollToContact}
                className="bg-[#DFFF00] text-black px-12 py-6 font-black uppercase tracking-widest text-lg flex items-center justify-center gap-3 hover:bg-white hover:scale-[1.02] active:scale-[0.98] transition-all cursor-pointer shadow-[0_0_30px_rgba(223,255,0,0.15)]"
              >
                Initialize Network
                <SafeIcon icon={FiArrowRight} />
              </button>
              <button 
                onClick={scrollToSolutions}
                className="border border-white/20 text-white px-12 py-6 font-black uppercase tracking-widest text-lg flex items-center justify-center gap-3 hover:bg-white/10 hover:border-white/40 transition-all cursor-pointer"
              >
                Infrastructure
              </button>
            </div>
          </motion.div>
        </div>

        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="mt-32 grid grid-cols-1 md:grid-cols-3 gap-12 border-t border-white/10 pt-16"
        >
          {[
            { title: 'Identity Nodes', desc: 'Every account built from scratch with unique digital fingerprints for total algorithmic resilience.', icon: FiLayers },
            { title: 'Mass Distribution', desc: 'Proprietary IP rotation keeps your distribution invisible to platform flags while scaling.', icon: FiShield },
            { title: 'Creative Forging', desc: 'Industrial AI engine producing commercials, influencers, and thousands of video variations.', icon: FiActivity },
          ].map((item, i) => (
            <div key={i} className="group">
              <div className="w-12 h-12 border border-white/10 flex items-center justify-center mb-6 group-hover:border-[#DFFF00] group-hover:bg-[#DFFF00]/5 transition-all duration-500">
                <SafeIcon icon={item.icon} className="text-[#DFFF00] text-xl" />
              </div>
              <h3 className="text-white text-lg font-black uppercase tracking-tight mb-3 italic">{item.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed font-medium uppercase tracking-wider">{item.desc}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}